import { CommonModule } from '@angular/common';
import { Component, inject } from '@angular/core';
import { ReactiveFormsModule, FormsModule } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatCardModule } from '@angular/material/card';
import { MAT_DIALOG_DATA, MatDialogActions, MatDialogContent, MatDialogRef } from '@angular/material/dialog';
import { MatDividerModule } from '@angular/material/divider';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { PixlEditorComponent } from '@wdidev/pixl-editor';

export interface PixlEditorDialogModel {
  explanationContentHtml: string
  authToken: string
  assetUrl: string
  mediaUrl: string
}

@Component({
  selector: 'pixl-pixl-editor-dialog',
  imports: [
    MatButtonModule,
    MatDialogActions,
    MatDialogContent,
    MatFormFieldModule,
    ReactiveFormsModule,
    MatDividerModule,
    MatCardModule,
    MatIconModule,
    FormsModule,
    CommonModule,
    PixlEditorComponent,
  ],
  templateUrl: './pixl-editor-dialog.component.html',
  styleUrl: './pixl-editor-dialog.component.scss'
})
export class PixlEditorDialogComponent {
  private readonly dialogRef = inject(MatDialogRef<PixlEditorDialogComponent>);
  public data = inject<PixlEditorDialogModel>(MAT_DIALOG_DATA);

  public onCancel(): void {
    this.dialogRef.close();
  }

  public onSave(): void {
    this.dialogRef.close(this.data);
  }
}
